import { Injectable} from '@angular/core';

import { ListingParams, EmailData } from '../_models/common/listingParams';
import { Notification } from '../_models/notification/toastr-notification.model';
@Injectable({
  providedIn: 'root'
})
export class DataPassService {

  public printParams = {} as ListingParams;
  public emailData = {} as EmailData;
  public notification = {} as Notification | null;
  public listingParams = {} as ListingParams;
  public passdata: any;
  public isQuickMenuOpen = true;


  constructor(
  ) {
  }

}
